import script from "./record-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./record-detail.vue?vue&type=script&setup=true&lang=js"

import "./record-detail.vue?vue&type=style&index=0&id=0fc7c5e5&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc7c5e5"]])

export default __exports__